export default __webpack_public_path__ + "static/car_2_door-72e5c830d7e6f04b2b03d5d0bc62bb40.svg";